// extracted by mini-css-extract-plugin
module.exports = {"loading_background":"login_loading_background__SJTom","svg":"login_svg__376km"};